import { Types } from '@amplitude/analytics-browser';
import { matchPath } from 'react-router-dom';

import { Pages } from 'modules/navigation/domain/enums/pages';

/** Раздел приложения в каждом событии — им отделяют игроков по ссылке на заявку от админов (IMGM-1609). */
export const APP_SECTION_PROPERTY = 'app_section';

export type AppSection = 'admin' | 'editor' | 'application-link' | 'auth';

/**
 * Пути — шаблоны из `Pages`, как в `modules/navigation/router.tsx`. `end: false` — у редакторов табло роут объявлен
 * с хвостом `/*`. Всё, чего здесь нет, — админка (шелл, выбор организатора).
 */
const SECTION_PATTERNS: ReadonlyArray<[AppSection, string]> = [
  ['application-link', Pages.APPLICATION_LINK.INDEX],
  ['application-link', Pages.APPLICATION_LINK.SUCCESS],
  ['editor', Pages.TEMPLATE.EDITOR],
  ['editor', Pages.TEMPLATE.PREVIEW],
  ['editor', Pages.MEDIA_MANAGER.EDITOR],
  ['auth', Pages.SIGN_IN],
  ['auth', Pages.SIGN_UP],
  ['auth', Pages.OAUTH_CONSENT],
];

export function resolveAppSection(pathname: string): AppSection {
  const found = SECTION_PATTERNS.find(([, path]) => matchPath({ path, end: false }, pathname));

  return found ? found[0] : 'admin';
}

/**
 * Обогащает каждое событие — и свои, и autocapture (`Page Viewed`, клики) — свойством `app_section` по текущему
 * адресу. Свои события на одной странице заявки не годились: клики и просмотры остались бы без метки.
 */
export function appSectionPlugin(): Types.EnrichmentPlugin {
  return {
    name: 'imgame-app-section',
    type: 'enrichment',
    execute: async (event) => ({
      ...event,
      event_properties: {
        ...event.event_properties,
        [APP_SECTION_PROPERTY]: resolveAppSection(window.location.pathname),
      },
    }),
  };
}
